import { Button } from "@mui/material";
import "./OnboardingScreen.css";
import "./SoftphoneDashboard.css";
import { TranslationKey, useTranslation } from "../i18n/LocaleContext";
import SupportLink from "./SupportLink";
import AppFooter from "./AppFooter";

interface BlockedStateScreenProps {
  titleKey: TranslationKey;
  copyKey: TranslationKey;
  /** Só passar quando repetir o check-in puder mudar o resultado. */
  onRetry?: () => void;
  /**
   * Ação secundária para o administrador do tenant abrir a tela de usuários daqui. Só é passada
   * nos dois bloqueios que ele próprio resolve — ramal não configurado e licença ausente —, e é
   * assim que um admin recém-cadastrado se configura sem depender da uTech.
   */
  onManageUsers?: () => void;
}

// Tela compartilhada dos estados em que o usuário não pode usar o softphone
// (aprovação pendente, acesso bloqueado, licença ou ramal ausentes).
//
// O texto mantém a orientação de procurar o administrador do tenant — a validação da loja
// exige que a dependência de setup por admin seja explicitada. O link de suporte é uma
// exigência separada: o contato precisa ser um hyperlink, não texto puro.
export default function BlockedStateScreen({ titleKey, copyKey, onRetry, onManageUsers }: BlockedStateScreenProps) {
  const { t } = useTranslation();

  return (
    <div className="softphone-shell onboarding-shell">
      <article className="status-card onboarding-card">
        <div className="onboarding-card-header">
          <div>
            <p className="eyebrow">{t("onboarding.eyebrow")}</p>
            <h1 className="onboarding-title">{t(titleKey)}</h1>
            <p className="onboarding-card-copy">{t(copyKey)}</p>
          </div>
        </div>

        <div className="onboarding-actions">
          {onRetry ? (
            <Button variant="contained" onClick={onRetry}>
              {t("blockedState.retry")}
            </Button>
          ) : null}
          {onManageUsers ? (
            <Button variant="outlined" onClick={onManageUsers}>
              {t("blockedState.manageUsers")}
            </Button>
          ) : null}
          <SupportLink className="app-footer-link blocked-state-support" />
        </div>
      </article>

      <AppFooter />
    </div>
  );
}
